import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import ClaimCard from './pages/ClaimCard';
import HomePage from './pages/HomePage.jsx';
import StartPage from './pages/StartPage.jsx';
import Collection from './pages/Collection';
import ScrollToTop from './components/ScrollToTop';
import { AppProvider } from './AppContext';
import { SDKProvider } from './context/sdk/provider';
import { Web3DevHubProvider } from './context/devhub/Web3DevHubContext';
import ProtectedRoute from './components/ProtectedRoute';
import AuthCallback from './components/AuthCallback';
import { ROUTES } from './routes/routeConstants';
import { UserProfileProvider } from './context/user/UserProfileContext';

function App() {

  return (
    <AppProvider>
      <SDKProvider>
        <UserProfileProvider>
          <Web3DevHubProvider>
            <Router>
              <ScrollToTop />
              <Routes>
                <Route path={ROUTES.ROOT} element={<StartPage/>}/>

                {/* Auth Routes */}
                <Route path={ROUTES.AUTH_CALLBACK} element={<AuthCallback fallbackComponent={<HomePage />}/>}/>

                <Route path={ROUTES.HOME} element={<HomePage/>}/>

                  {/* Private Routes for authenticated users */}
                <Route path={ROUTES.CLAIM_CARD}
                  element={
                  <ProtectedRoute>
                    <ClaimCard/>
                  </ProtectedRoute>
                  }/>

                <Route path={ROUTES.COLLECTION}
                  element={
                  <ProtectedRoute>
                    <Collection/>
                  </ProtectedRoute>
                  }/>

                <Route path={ROUTES.NOT_FOUND} element={<Navigate to="/home" />} />
              </Routes>
            </Router>
          </Web3DevHubProvider>
        </UserProfileProvider>
      </SDKProvider>
    </AppProvider>
  );
}

export default App;
